import {useSelector} from 'Provider';
import {DateTime} from 'luxon';
import React, {useEffect, useState} from 'react';

import FilterDisplay from 'components/Offers/Filters/FIlterDisplay/FilterDisplay';
import {
  availableTypesSelector,
  selectedDestinationSelector,
  selectedEndDateSelector,
  selectedOfferTypeFilterSelector,
  selectedProptertiesSelector,
  selectedStartDateSelector,
} from 'store/offers/offers.selectors';

const ConnectedFilterDisplay = () => {
  const availableTypes = useSelector(availableTypesSelector);
  const selectedDestination = useSelector(selectedDestinationSelector);
  const selectedProperties = useSelector(selectedProptertiesSelector);
  const selectedStartDate = useSelector(selectedStartDateSelector);
  const selectedEndDate = useSelector(selectedEndDateSelector);
  const selectedTypes = useSelector(selectedOfferTypeFilterSelector);

  const [extraFilterCount, setExtraFilterCount] = useState(0);
  const [displayedFilter, setDisplayedFilter] = useState<string>('');

  useEffect(() => {
    let counter = 0;
    let title = '';

    if (selectedDestination) {
      title = selectedDestination.name;

      if (selectedProperties) {
        counter += selectedProperties.length;
      }
    }

    if (selectedStartDate && selectedEndDate) {
      if (!title) {
        title = `${DateTime.fromISO(selectedStartDate).toFormat(
          'LLL d'
        )} - ${DateTime.fromISO(selectedEndDate).toFormat('LLL d')}`;
      } else {
        counter += 1;
      }
    }

    if (selectedTypes && selectedTypes.length !== availableTypes.length) {
      if (selectedDestination || (selectedStartDate && selectedEndDate)) {
        counter += selectedTypes.length;
      } else if (counter > 0 || selectedTypes.length > 1) {
        counter += selectedTypes.length - 1;
      }
      if (title.length === 0) {
        title = selectedTypes[0];
      }
    }

    setExtraFilterCount(counter);
    setDisplayedFilter(title);
  }, [
    selectedDestination,
    selectedProperties,
    selectedStartDate,
    selectedEndDate,
    selectedTypes,
    availableTypes,
  ]);

  return (
    <FilterDisplay
      displayedFilter={displayedFilter}
      extraFilterCount={extraFilterCount}
    />
  );
};

export default ConnectedFilterDisplay;
